import DocumentHeader from 'Components/DocumentHeader';
import DocumentWrapper from 'Components/DocumentWrapper';
import PlatformConditional from 'Components/PlatformConditional';
import FormEditingHandler from 'Containers/FormEditingHandler';
import * as React from 'react';
import { getHeaderId } from '../utils';
import Form from './Form';
import PBASHistory from './HistoryRowData/PBAS';

const BehaviourHistory = (
  documents: Array<IDocumentWithTypeV2<'pbaS'>>,
  startEdit: StartEdit,
  view?: IView,
): React.JSX.Element => {
  return (
    <React.Fragment>
      <PlatformConditional platform={'huntington'}>
        <React.Fragment>
          <PBASHistory documents={documents} startEdit={startEdit} view={view} />
        </React.Fragment>
      </PlatformConditional>
    </React.Fragment>
  );
};

const Behaviour = ({ documents }: IOwnProps): React.JSX.Element => (
  <FormEditingHandler name="behaviour" documents={documents}>
    {(editing, startEdit, formData, view): React.JSX.Element => (
      <DocumentWrapper>
        <DocumentHeader
          name={'behaviour'}
          headerId={getHeaderId(documents, editing, view?.viewing)}
          editing={editing}
          editButtons={<div />}
        />
        {editing ? <Form formData={formData} document={documents.find(d => d._id === editing)} /> : null}
        {view?.viewing ? (
          <Form
            formData={{ document: view.document, onChange: (): string => '' }}
            document={documents.find(d => d._id === view.viewing)}
            viewing={!!view.viewing}
          />
        ) : null}
        {!editing && !view?.viewing ? BehaviourHistory(documents, startEdit, view) : null}
      </DocumentWrapper>
    )}
  </FormEditingHandler>
);

interface IOwnProps {
  documents: Array<IDocumentWithTypeV2<'pbaS'>>;
}

export default Behaviour;
